import type { ToolDefinition } from '../../../types/tool-registry.js';
export const historicalPeriodTools: readonly ToolDefinition[] = [
  {
    "toolId": "salary",
    "slug": "maas-hesaplama",
    "path": "/bireysel-finans/maas-hesaplama",
    "category": {
      "id": "bireysel-finans",
      "label": "Bireysel Finans"
    },
    "classification": "remote-config",
    "engineId": "salary-annual-average-v1",
    "schemaVersion": "1.0.0",
    "contentVersion": "2026.8.18",
    "configVersion": "2026.1.0",
    "effectiveFrom": "2026-01-01",
    "effectiveTo": "2026-12-31",
    "minAppVersion": "0.1.0",
    "updateCadence": {
      "mode": "scheduled-source-review",
      "days": 7,
      "reviewAfter": "2027-01-01",
      "specialMonths": [
        1,
        7,
        12
      ],
      "note": "SGK ve ücret parametreleri en geç yedi günde bir; gelir vergisi ve damga vergisi kaynakları kendi daha uzun periyotlarıyla ayrıca izlenir."
    },
    "sources": [
      {
        "sourceId": "gib-income-tax-2026",
        "sourceGroupId": "tr_income_tax_tariff",
        "title": "2026 gelir vergisi tarifesi",
        "publisher": "Gelir İdaresi Başkanlığı",
        "url": "https://cdn.gib.gov.tr/api/gibportal-file/file/getFileResources?objectKey=arsiv%2Fyardim-kaynaklar%2Fyararli-bilgiler%2Fgelir-vergisi-tarifeleri%2Fgelir-vergisi-tarifesi-2026.pdf",
        "kind": "official-government",
        "reviewedOn": "2026-08-18",
        "watchFields": [
          "ücret geliri vergi dilimleri",
          "matrah eşikleri",
          "vergi oranları"
        ]
      },
      {
        "sourceId": "sgk-pec-2026",
        "sourceGroupId": "tr_labor_sgk_annual",
        "title": "2026 prime esas kazanç miktarları",
        "publisher": "Sosyal Güvenlik Kurumu",
        "url": "https://www.sgk.gov.tr/Content/Post/2e0c9e1a-2cfe-4456-af10-49d3de0c58ba/Prime-Esas-Kazanc-Miktarlari-2026-01-14-10-35-39",
        "kind": "official-government",
        "reviewedOn": "2026-08-18",
        "watchFields": [
          "asgari ücret",
          "prime esas kazanç alt sınırı",
          "prime esas kazanç üst sınırı"
        ]
      },
      {
        "sourceId": "sgk-employer-rates-2026",
        "sourceGroupId": "tr_labor_sgk_annual",
        "title": "İşveren prim oranları",
        "publisher": "Sosyal Güvenlik Kurumu",
        "url": "https://www.sgk.gov.tr/Content/Post/c7812ea8-5087-413f-aeb5-d3c1d153e11a/Isveren-Prim-Oranlari-2026-01-13-04-52-38",
        "kind": "official-government",
        "reviewedOn": "2026-08-18",
        "watchFields": [
          "işçi ve işveren prim oranları",
          "işsizlik sigortası payları"
        ]
      },
      {
        "sourceId": "csgb-wage-statistics-2026-07",
        "sourceGroupId": "tr_labor_sgk_annual",
        "title": "Temmuz 2026 ücret ve sendikal istatistikleri",
        "publisher": "Çalışma ve Sosyal Güvenlik Bakanlığı",
        "url": "https://www.csgb.gov.tr/yayinlar/calisma-hayati-istatistikleri-e-bulteni/temmuz-2026/ucret-ve-sendikal-istatistikler.html",
        "kind": "official-government",
        "reviewedOn": "2026-08-18",
        "watchFields": [
          "ücret dönemi",
          "asgari ücret"
        ]
      },
      {
        "sourceId": "gib-stamp-tax-current",
        "sourceGroupId": "tr_stamp_tax",
        "title": "Vergi beyannamelerinde uygulanan damga vergisi tutarları",
        "publisher": "Gelir İdaresi Başkanlığı",
        "url": "https://cdn.gib.gov.tr/api/gibportal-file/file/getFileResources?objectKey=arsiv%2Fyardim-kaynaklar%2Fyararli-bilgiler%2Fvergi-beyannamelerinde-uygulanan-damga-vergisi-tutarlari.pdf",
        "kind": "official-government",
        "reviewedOn": "2026-08-18",
        "watchFields": [
          "nispi damga vergisi oranı",
          "istisna"
        ]
      }
    ],
    "inputSchema": {
      "type": "object",
      "fields": [
        {
          "id": "mode",
          "type": "radio",
          "label": "Hesaplama Yöntemi",
          "required": true,
          "defaultValue": "gross-to-net",
          "placeholder": null,
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [
            {
              "value": "gross-to-net",
              "label": "Brütten Nete"
            },
            {
              "value": "net-to-gross",
              "label": "Netten Brüte"
            }
          ],
          "visibleWhen": null
        },
        {
          "id": "monthlyAmount",
          "type": "number",
          "label": "Aylık Maaş Tutarı",
          "required": true,
          "defaultValue": null,
          "placeholder": "0,00",
          "unit": "TL",
          "minimum": 1,
          "maximum": 1000000000,
          "maxDecimalPlaces": 2,
          "options": [],
          "visibleWhen": null
        }
      ]
    },
    "resultSchema": {
      "type": "object",
      "fields": [
        {
          "id": "gross",
          "type": "money",
          "label": "Aylık Brüt",
          "unit": "TL",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "employeeSgk",
          "type": "money",
          "label": "SGK İşçi Payı",
          "unit": "TL",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "employeeUnemployment",
          "type": "money",
          "label": "İşsizlik İşçi Payı",
          "unit": "TL",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "incomeTax",
          "type": "money",
          "label": "Gelir Vergisi",
          "unit": "TL",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "stampTax",
          "type": "money",
          "label": "Damga Vergisi",
          "unit": "TL",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "net",
          "type": "money",
          "label": "Yıllık Ortalama Aylık Net",
          "unit": "TL",
          "nullable": false,
          "prominent": true
        }
      ]
    },
    "content": {
      "title": "Maaş Hesaplama (Brütten Nete ve Netten Brüte) — 2026",
      "shortTitle": "Maaş Hesaplama",
      "summary": "Brüt veya net maaştan diğerini; 2026 vergi dilimleri, SGK, işsizlik sigortası, damga vergisi ve asgari ücret istisnasıyla hesaplar.",
      "method": "Standart 4/a çalışanında 12 aylık brüt ücret üzerinden yıllık vergi ve kesintiler hesaplanır; yıllık net tutar 12'ye bölünerek yıllık ortalama aylık net bulunur. Prime esas kazanç üzerinden işçi SGK payı %14 ve işsizlik payı %1 uygulanır.",
      "limitations": [
        "Sonuç belirli bir ayın bordrosu değil, yıllık verginin 12 aya bölünmüş ortalamasıdır.",
        "Prim, ikramiye, engellilik indirimi, yemek ve yol istisnası, eksik gün, özel sigorta veya başka gelirler bu modelde yer almaz.",
        "İşveren primi çalışanın net ücretinden kesilmez ve bu aracın sonucuna dahil değildir."
      ],
      "faqs": [
        {
          "question": "Bu sonuç belirli bir ayın bordrosu mudur?",
          "answer": "Hayır. Araç 12 aylık vergi matrahını hesaplayıp yıllık neti 12'ye böler; sonuç yıllık ortalama aylık nettir. Gerçek aylık net kümülatif matraha göre değişir."
        },
        {
          "question": "2026 SGK prime esas kazanç tavanı nedir?",
          "answer": "2026 aylık prime esas kazanç alt sınırı 33.030 TL, üst sınırı bunun 9 katı olan 297.270 TL'dir. İşçi SGK ve işsizlik kesintileri bu sınırlar içinde hesaplanır."
        },
        {
          "question": "Hangi işçi kesintileri uygulanır?",
          "answer": "Standart 4/a varsayımında işçi SGK payı %14, işsizlik payı %1, gelir vergisi artan oranlı tarife ve damga vergisi uygulanır; asgari ücret vergi istisnası hesaba katılır."
        },
        {
          "question": "İşveren primi sonuçta var mı?",
          "answer": "İşveren primi net ücretten düşülmez. Teşvikli veya indirimsiz işveren maliyeti ayrı İşveren Maliyeti aracında gerçek senaryoyla hesaplanmalıdır."
        }
      ]
    },
    "config": {
      "kind": "salary-annual-rules-v1",
      "calendarYear": 2026,
      "monthsPerYear": 12,
      "minimumGrossWage": 33030,
      "socialSecurityEmployeeRate": 0.14,
      "unemploymentEmployeeRate": 0.01,
      "stampTaxRate": 0.00759,
      "socialSecurityCeilingMultiplier": 9,
      "incomeTaxBrackets": [
        {
          "upTo": 190000,
          "rate": 0.15
        },
        {
          "upTo": 400000,
          "rate": 0.2
        },
        {
          "upTo": 1500000,
          "rate": 0.27
        },
        {
          "upTo": 5300000,
          "rate": 0.35
        },
        {
          "upTo": null,
          "rate": 0.4
        }
      ],
      "netToGrossIteration": {
        "initialMultiplier": 1.4,
        "maxIterations": 50,
        "tolerance": 0.01,
        "correctionFactor": 1.3
      }
    },
    "testVectors": {
      "kind": "salary-golden-v1",
      "cases": [
        {
          "caseId": "gross-50000",
          "input": {
            "mode": "gross-to-net",
            "monthlyAmount": 50000
          },
          "expected": {
            "gross": 50000,
            "employeeSgk": 7000.000000000001,
            "employeeUnemployment": 500,
            "incomeTax": 3526.566666666667,
            "stampTax": 128.80229999999997,
            "net": 38844.63103333333
          },
          "tolerance": 1e-08,
          "formattedNet": "38.844,63"
        },
        {
          "caseId": "net-38844-631033",
          "input": {
            "mode": "net-to-gross",
            "monthlyAmount": 38844.63103333333
          },
          "expected": {
            "gross": 50000,
            "employeeSgk": 7000.000000000001,
            "employeeUnemployment": 500,
            "incomeTax": 3526.566666666667,
            "stampTax": 128.80229999999997,
            "net": 38844.63103333333
          },
          "tolerance": 0.02,
          "formattedNet": null
        }
      ]
    },
    "lastReviewed": "2026-08-18"
  },
  {
    "toolId": "hgs-toll",
    "slug": "hgs-gecis-ucreti-hesaplama",
    "path": "/arac-emlak-yasam/hgs-gecis-ucreti-hesaplama",
    "category": {
      "id": "arac-emlak-yasam",
      "label": "Araç, Emlak ve Yaşam"
    },
    "classification": "remote-config",
    "engineId": "hgs-fixed-toll-v1",
    "schemaVersion": "1.0.0",
    "contentVersion": "2026.10.28",
    "configVersion": "2026.10.28",
    "effectiveFrom": "2026-07-01",
    "effectiveTo": null,
    "minAppVersion": "0.1.0",
    "updateCadence": {
      "mode": "scheduled-source-review",
      "days": 7,
      "reviewAfter": "2027-01-01",
      "specialMonths": [
        1,
        7
      ],
      "note": "KGM ve işletmeci tarifeleri yedi günde bir izlenir; yeni tutar ancak kaynak, altın test ve insan onayından sonra yayımlanır."
    },
    "sources": [
      {
        "sourceId": "kgm-current-tolls",
        "sourceGroupId": "tr_highway_bridge_tunnel_tolls",
        "title": "Güncel otoyol ve köprü ücretleri",
        "publisher": "Karayolları Genel Müdürlüğü",
        "url": "https://www.kgm.gov.tr/sayfalar/kgm/sitetr/otoyollar/ucretleryeni.aspx?v=1.0.22",
        "kind": "official-government",
        "reviewedOn": "2026-10-28",
        "watchFields": [
          "tesis",
          "araç sınıfı",
          "tek yön ücret",
          "yürürlük tarihi"
        ]
      },
      {
        "sourceId": "eurasia-tunnel-2026-07",
        "sourceGroupId": "tr_highway_bridge_tunnel_tolls",
        "title": "1 Temmuz 2026 itibarıyla geçerli Avrasya Tüneli geçiş ücretleri",
        "publisher": "Avrasya Tüneli İşletme İnşaat ve Yatırım A.Ş.",
        "url": "https://www.avrasyatuneli.com/haberler-ve-duyurular/detay/1-temmuz-2026-itibariyla-gecerli-avrasya-tuneli-gecis-ucretleri-tarifesi",
        "kind": "official-operator",
        "reviewedOn": "2026-10-28",
        "watchFields": [
          "araç sınıfı",
          "gündüz ve gece",
          "tek yön ücret",
          "yürürlük tarihi"
        ]
      }
    ],
    "inputSchema": {
      "type": "object",
      "fields": [
        {
          "id": "vehicleClass",
          "type": "select",
          "label": "Araç Sınıfı",
          "required": true,
          "defaultValue": "class-1",
          "placeholder": null,
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [
            {
              "value": "class-1",
              "label": "1. sınıf — Otomobil"
            },
            {
              "value": "class-2",
              "label": "2. sınıf — Minibüs/Kamyonet/Karavan"
            },
            {
              "value": "class-3",
              "label": "3. sınıf — Otobüs (3 aks)"
            },
            {
              "value": "class-4",
              "label": "4. sınıf — Kamyon/TIR (4-5 aks)"
            },
            {
              "value": "class-5",
              "label": "5. sınıf — Ağır vasıta (6+ aks)"
            },
            {
              "value": "class-6",
              "label": "6. sınıf — Motosiklet"
            }
          ],
          "visibleWhen": null
        },
        {
          "id": "crossing",
          "type": "select",
          "label": "Geçiş",
          "required": true,
          "defaultValue": null,
          "placeholder": "Lütfen seçiniz",
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [
            {
              "value": "15-temmuz",
              "label": "15 Temmuz Şehitler Köprüsü"
            },
            {
              "value": "fsm",
              "label": "Fatih Sultan Mehmet Köprüsü"
            },
            {
              "value": "yss",
              "label": "Yavuz Sultan Selim Köprüsü"
            },
            {
              "value": "osmangazi",
              "label": "Osmangazi Köprüsü"
            },
            {
              "value": "1915-canakkale",
              "label": "1915 Çanakkale Köprüsü"
            },
            {
              "value": "avrasya",
              "label": "Avrasya Tüneli"
            }
          ],
          "visibleWhen": null
        },
        {
          "id": "time",
          "type": "select",
          "label": "Geçiş Zamanı",
          "required": true,
          "defaultValue": "gunduz",
          "placeholder": null,
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [
            {
              "value": "gunduz",
              "label": "Gündüz (05:00-23:59)"
            },
            {
              "value": "gece",
              "label": "Gece (00:00-04:59)"
            }
          ],
          "visibleWhen": {
            "fieldId": "crossing",
            "equals": "avrasya"
          }
        },
        {
          "id": "direction",
          "type": "select",
          "label": "Yön",
          "required": true,
          "defaultValue": "tek",
          "placeholder": null,
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [
            {
              "value": "tek",
              "label": "Tek Yön"
            },
            {
              "value": "cift",
              "label": "Gidiş-Dönüş (×2)"
            }
          ],
          "visibleWhen": null
        }
      ]
    },
    "resultSchema": {
      "type": "object",
      "fields": [
        {
          "id": "allowed",
          "type": "boolean",
          "label": "Hesaplanabilir",
          "unit": null,
          "nullable": false,
          "prominent": false
        },
        {
          "id": "crossingName",
          "type": "text",
          "label": "Geçiş",
          "unit": null,
          "nullable": false,
          "prominent": false
        },
        {
          "id": "vehicleClassName",
          "type": "text",
          "label": "Araç Sınıfı",
          "unit": null,
          "nullable": false,
          "prominent": false
        },
        {
          "id": "oneWayFee",
          "type": "money",
          "label": "Tek Yön Ücreti",
          "unit": "TL",
          "nullable": true,
          "prominent": false
        },
        {
          "id": "time",
          "type": "text",
          "label": "Geçiş Zamanı",
          "unit": null,
          "nullable": false,
          "prominent": false
        },
        {
          "id": "totalFee",
          "type": "money",
          "label": "Toplam Geçiş Ücreti",
          "unit": "TL",
          "nullable": true,
          "prominent": true
        },
        {
          "id": "direction",
          "type": "text",
          "label": "Yön",
          "unit": null,
          "nullable": false,
          "prominent": false
        },
        {
          "id": "reason",
          "type": "text",
          "label": "Hesaplanamama Nedeni",
          "unit": null,
          "nullable": true,
          "prominent": false
        }
      ]
    },
    "content": {
      "title": "HGS Köprü ve Tünel Geçiş Ücreti Hesaplama 2026",
      "shortTitle": "HGS Geçiş Ücreti",
      "summary": "Araç sınıfı, köprü veya tünel, geçiş zamanı ve yön seçimine göre güncel sabit tarife üzerinden geçiş ücretini hesaplar.",
      "method": "KGM köprü ücretleri 2026 merkezi tarifesinden; Avrasya Tüneli ücretleri 1 Temmuz 2026 tarifesinden alınır. Seçili araç sınıfının tek yön tutarı, gidiş-dönüş seçiminde ikiyle çarpılır. Avrasya gece tarifesi yalnız 00:00-04:59 aralığı için kullanılır.",
      "limitations": [
        "Araç yalnız listelenen sabit tarifeli köprü ve tünelleri kapsar; otoyol giriş-çıkışına bağlı mesafe ücreti ayrıca KGM sorgusundan kontrol edilmelidir.",
        "HGS sınıfı aks sayısı ve aks aralığına göre belirlenir; ruhsat türü tek başına yeterli değildir.",
        "İhlalli geçiş cezası, tahsilat süresi ve bakiye işlemleri hesaplamaya dahil değildir."
      ],
      "faqs": [
        {
          "question": "Avrasya Tüneli 1 Temmuz 2026 ücretleri nedir?",
          "answer": "Gündüz 1. sınıf 330 TL, 2. sınıf 495 TL, motosiklet 257,40 TL; gece 00:00-04:59 arasında sırasıyla 165 TL, 247,50 TL ve 128,70 TL'dir."
        },
        {
          "question": "KGM köprü ücretleri hangi döneme aittir?",
          "answer": "KGM köprü tutarları 2026 güncel merkezi tarifesinden; Avrasya tutarları ise 1 Temmuz 2026 özel tarifesinden alınır."
        },
        {
          "question": "Araç sınıfı nasıl belirlenir?",
          "answer": "Sınıf aks sayısı ve aks aralığına göre belirlenir. Standart otomobil 1. sınıftır; HGS hesabındaki resmî araç sınıfı esas alınmalıdır."
        },
        {
          "question": "Otoyol mesafe ücreti dahil midir?",
          "answer": "Hayır. Araç sabit tarifeli seçili köprü ve tünelleri hesaplar. Otoyol giriş-çıkış mesafe ücreti KGM'nin güncel sorgusundan ayrıca kontrol edilmelidir."
        }
      ]
    },
    "config": {
      "kind": "hgs-fixed-tariffs-v1",
      "currency": "TRY",
      "vatIncluded": true,
      "roundTripMultiplier": 2,
      "nightWindow": {
        "start": "00:00",
        "end": "05:00"
      },
      "vehicleClasses": [
        {
          "id": "class-1",
          "label": "1. sınıf (Otomobil)"
        },
        {
          "id": "class-2",
          "label": "2. sınıf (Minibüs/Kamyonet)"
        },
        {
          "id": "class-3",
          "label": "3. sınıf (Otobüs)"
        },
        {
          "id": "class-4",
          "label": "4. sınıf (Kamyon/TIR)"
        },
        {
          "id": "class-5",
          "label": "5. sınıf (Ağır vasıta)"
        },
        {
          "id": "class-6",
          "label": "6. sınıf (Motosiklet)"
        }
      ],
      "crossings": [
        {
          "id": "15-temmuz",
          "label": "15 Temmuz Şehitler Köprüsü",
          "effectiveFrom": "2026-01-01",
          "pricesByVehicleClass": {
            "class-1": 59,
            "class-2": 75,
            "class-3": 168,
            "class-4": 333,
            "class-5": 440,
            "class-6": 25
          },
          "nightPricesByVehicleClass": null
        },
        {
          "id": "fsm",
          "label": "Fatih Sultan Mehmet Köprüsü",
          "effectiveFrom": "2026-01-01",
          "pricesByVehicleClass": {
            "class-1": 59,
            "class-2": 75,
            "class-3": 168,
            "class-4": 333,
            "class-5": 440,
            "class-6": 25
          },
          "nightPricesByVehicleClass": null
        },
        {
          "id": "yss",
          "label": "Yavuz Sultan Selim Köprüsü",
          "effectiveFrom": "2026-07-01",
          "pricesByVehicleClass": {
            "class-1": 110,
            "class-2": 145,
            "class-3": 270,
            "class-4": 690,
            "class-5": 860,
            "class-6": 75
          },
          "nightPricesByVehicleClass": null
        },
        {
          "id": "osmangazi",
          "label": "Osmangazi Köprüsü",
          "effectiveFrom": "2026-07-01",
          "pricesByVehicleClass": {
            "class-1": 1170,
            "class-2": 1870,
            "class-3": 2225,
            "class-4": 2950,
            "class-5": 3720,
            "class-6": 820
          },
          "nightPricesByVehicleClass": null
        },
        {
          "id": "1915-canakkale",
          "label": "1915 Çanakkale Köprüsü",
          "effectiveFrom": "2026-07-01",
          "pricesByVehicleClass": {
            "class-1": 1170,
            "class-2": 1465,
            "class-3": 2635,
            "class-4": 2925,
            "class-5": 5560,
            "class-6": 295
          },
          "nightPricesByVehicleClass": null
        },
        {
          "id": "avrasya",
          "label": "Avrasya Tüneli",
          "effectiveFrom": "2026-07-01",
          "pricesByVehicleClass": {
            "class-1": 330,
            "class-2": 495,
            "class-3": null,
            "class-4": null,
            "class-5": null,
            "class-6": 257.4
          },
          "nightPricesByVehicleClass": {
            "class-1": 165,
            "class-2": 247.5,
            "class-3": null,
            "class-4": null,
            "class-5": null,
            "class-6": 128.7
          }
        }
      ]
    },
    "testVectors": {
      "kind": "hgs-matrix-v1",
      "vehicleClasses": [
        "class-1",
        "class-2",
        "class-3",
        "class-4",
        "class-5",
        "class-6"
      ],
      "times": [
        "gunduz",
        "gece"
      ],
      "directions": [
        "tek",
        "cift"
      ],
      "roundTripMultiplier": 2,
      "nightWindow": {
        "startInclusive": "00:00",
        "endExclusive": "05:00"
      },
      "crossings": [
        {
          "crossing": "15-temmuz",
          "standardFees": [
            59,
            75,
            168,
            333,
            440,
            25
          ],
          "nightFees": null
        },
        {
          "crossing": "fsm",
          "standardFees": [
            59,
            75,
            168,
            333,
            440,
            25
          ],
          "nightFees": null
        },
        {
          "crossing": "yss",
          "standardFees": [
            110,
            145,
            270,
            690,
            860,
            75
          ],
          "nightFees": null
        },
        {
          "crossing": "osmangazi",
          "standardFees": [
            1170,
            1870,
            2225,
            2950,
            3720,
            820
          ],
          "nightFees": null
        },
        {
          "crossing": "1915-canakkale",
          "standardFees": [
            1170,
            1465,
            2635,
            2925,
            5560,
            295
          ],
          "nightFees": null
        },
        {
          "crossing": "avrasya",
          "standardFees": [
            330,
            495,
            null,
            null,
            null,
            257.4
          ],
          "nightFees": [
            165,
            247.5,
            null,
            null,
            null,
            128.7
          ]
        }
      ]
    },
    "lastReviewed": "2026-10-28"
  },
  {
    "toolId": "depreciation-plan",
    "slug": "amortisman-hesaplama",
    "path": "/ticari-muhasebe/amortisman-hesaplama",
    "category": {
      "id": "ticari-muhasebe",
      "label": "Ticari ve Muhasebe"
    },
    "classification": "timeless",
    "engineId": "depreciation-plan-v1",
    "schemaVersion": "1.0.0",
    "contentVersion": "1.0.0",
    "configVersion": "1.0.0",
    "effectiveFrom": "2026-08-24",
    "effectiveTo": null,
    "minAppVersion": "0.3.0",
    "updateCadence": {
      "mode": "method-change-only",
      "days": null,
      "reviewAfter": null,
      "specialMonths": [],
      "note": "Saf matematik çekirdeği yöntem değişene kadar çalışır; varsa dönemsel alt politika yalnız ilgili modu kapatır."
    },
    "sources": [
      {
        "sourceId": "tr-vuk-depreciation",
        "sourceGroupId": null,
        "title": "Amortismana Tabi İktisadi Kıymetler Tablosu",
        "publisher": "Gelir İdaresi Başkanlığı",
        "url": "https://cdn.gib.gov.tr/api/gibportal-file/file/getFileResources?objectKey=arsiv%2Fyardim-kaynaklar%2Fyararli-bilgiler%2FAmortismanOranlariTablosu.pdf",
        "kind": "official-government",
        "reviewedOn": "2026-08-24",
        "watchFields": [
          "Faydalı ömür ve normal amortisman oranı tablosu"
        ]
      },
      {
        "sourceId": "tr-vuk-depreciation-methods",
        "sourceGroupId": null,
        "title": "213 sayılı Vergi Usul Kanunu — Mükerrer 315 Azalan Bakiyeler Usulüyle Amortisman",
        "publisher": "Gelir İdaresi Başkanlığı",
        "url": "https://www.gib.gov.tr/mevzuat/kanun/434",
        "kind": "official-government",
        "reviewedOn": "2026-08-24",
        "watchFields": [
          "Azalan bakiyeler yönteminin uygunluk şartları",
          "Normal oran çarpanı ve azami oran"
        ]
      }
    ],
    "inputSchema": {
      "type": "object",
      "fields": [
        {
          "defaultValue": null,
          "placeholder": null,
          "unit": "TRY",
          "minimum": 1,
          "maximum": 1000000000,
          "maxDecimalPlaces": 4,
          "options": [],
          "visibleWhen": null,
          "id": "cost",
          "type": "number",
          "label": "Maliyet bedeli",
          "required": true
        },
        {
          "defaultValue": null,
          "placeholder": null,
          "unit": "yıl",
          "minimum": 1,
          "maximum": 100,
          "maxDecimalPlaces": 0,
          "options": [],
          "visibleWhen": null,
          "id": "usefulLifeYears",
          "type": "number",
          "label": "Faydalı ömür",
          "required": true
        },
        {
          "defaultValue": "straight-line",
          "placeholder": null,
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [
            {
              "value": "straight-line",
              "label": "Normal amortisman"
            },
            {
              "value": "declining-balance",
              "label": "Azalan bakiyeler"
            }
          ],
          "visibleWhen": null,
          "id": "method",
          "type": "radio",
          "label": "Yöntem",
          "required": true
        },
        {
          "defaultValue": false,
          "placeholder": null,
          "unit": null,
          "minimum": null,
          "maximum": null,
          "maxDecimalPlaces": null,
          "options": [],
          "visibleWhen": {
            "fieldId": "method",
            "equals": "declining-balance"
          },
          "id": "decliningBalanceEligibilityConfirmed",
          "type": "boolean",
          "label": "Azalan bakiyeler uygunluğunu doğruladım",
          "required": false
        }
      ]
    },
    "resultSchema": {
      "type": "object",
      "fields": [
        {
          "id": "cost",
          "type": "money",
          "label": "Maliyet",
          "unit": "TRY",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "usefulLifeYears",
          "type": "number",
          "label": "Faydalı ömür",
          "unit": "yıl",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "method",
          "type": "text",
          "label": "Yöntem",
          "unit": null,
          "nullable": false,
          "prominent": false
        },
        {
          "id": "depreciationRatePercent",
          "type": "percentage",
          "label": "Amortisman oranı",
          "unit": "%",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "firstYearExpense",
          "type": "money",
          "label": "İlk yıl gideri",
          "unit": "TRY",
          "nullable": false,
          "prominent": true
        },
        {
          "id": "totalDepreciation",
          "type": "money",
          "label": "Toplam amortisman",
          "unit": "TRY",
          "nullable": false,
          "prominent": false
        },
        {
          "id": "schedule",
          "type": "object-list",
          "label": "Amortisman planı",
          "unit": null,
          "nullable": false,
          "prominent": false
        }
      ]
    },
    "content": {
      "title": "VUK Amortisman Planı Ön Hesabı",
      "shortTitle": "Amortisman Planı",
      "summary": "Kullanıcının resmî tablodan seçtiği faydalı ömürle normal veya uygunluğu doğrulanmış azalan bakiyeler ön planı üretir.",
      "method": "Normal yöntemde maliyet ömre eşit dağılır. Azalan bakiyelerde sürümlü çarpan ve tavan uygulanır; son yıl kalan defter değeri sıfırlanır.",
      "limitations": [
        "Faydalı ömür genel bir varlık sınıfından tahmin edilmez; ilgili iktisadi kıymet satırı GİB tablosundan bulunup kullanıcı tarafından girilmelidir. Azalan bakiyeler için bilanço esası, kıymet ve daha önce seçilen yöntem uygunluğu ayrıca doğrulanmalıdır."
      ],
      "faqs": [
        {
          "question": "Amortisman Planı kesin resmî veya banka sonucu verir mi?",
          "answer": "Hayır. Araç yalnız gösterilen formülü, kullanıcı girdilerini ve yürürlük kaydı açık politika alanlarını uygular. Sözleşme, banka planı veya mükellef özelindeki kesin sonuç ilgili kurum ve uzman kaydıyla doğrulanmalıdır."
        }
      ],
      "sourcePanel": {
        "title": "Kaynak ve politika kapsamı",
        "summary": "Kullanıcı girdili temel matematik zamansızdır. Yalnız dönemsel politika kullanan mod, politika sona erdiğinde veya inceleme tarihi geldiğinde yeni insan onayı olmadan kapanır.",
        "sourceIds": [
          "tr-vuk-depreciation",
          "tr-vuk-depreciation-methods"
        ],
        "notes": [
          "Oran, eşik ve hukuki uygunluk matematik çekirdeğine gömülü değildir."
        ]
      }
    },
    "config": {
      "kind": "depreciation-plan-v1",
      "policyLifecycle": {
        "configVersion": "1.0.0",
        "sourceIds": [
          "tr-vuk-depreciation"
        ],
        "reviewedOn": "2026-08-24",
        "effectiveFrom": "2026-08-24",
        "effectiveTo": null,
        "reviewAfter": null
      },
      "cost": [
        1,
        1000000000
      ],
      "policy": {
        "decliningBalanceMultiplier": 2,
        "maximumDecliningRate": 0.5,
        "policyLifecycle": {
          "configVersion": "1.0.0",
          "sourceIds": [
            "tr-vuk-depreciation-methods"
          ],
          "reviewedOn": "2026-08-24",
          "effectiveFrom": "2026-08-24",
          "effectiveTo": "2026-12-31",
          "reviewAfter": "2027-01-01"
        }
      }
    },
    "testVectors": {
      "kind": "finance-business-oracle-v1",
      "cases": [
        {
          "caseId": "straight-line-five-years",
          "scenario": "positive",
          "input": {
            "cost": 100000,
            "usefulLifeYears": 5,
            "method": "straight-line"
          },
          "expected": {
            "ok": true,
            "value": {
              "cost": 100000,
              "usefulLifeYears": 5,
              "method": "straight-line",
              "depreciationRatePercent": 20,
              "firstYearExpense": 20000,
              "totalDepreciation": 100000,
              "schedule": [
                {
                  "year": 1,
                  "expense": 20000,
                  "cumulativeDepreciation": 20000,
                  "netBookValue": 80000
                },
                {
                  "year": 2,
                  "expense": 20000,
                  "cumulativeDepreciation": 40000,
                  "netBookValue": 60000
                },
                {
                  "year": 3,
                  "expense": 20000,
                  "cumulativeDepreciation": 60000,
                  "netBookValue": 40000
                },
                {
                  "year": 4,
                  "expense": 20000,
                  "cumulativeDepreciation": 80000,
                  "netBookValue": 20000
                },
                {
                  "year": 5,
                  "expense": 20000,
                  "cumulativeDepreciation": 100000,
                  "netBookValue": 0
                }
              ]
            }
          },
          "tolerance": 1e-09
        },
        {
          "caseId": "declining-without-confirmation",
          "scenario": "adversarial",
          "input": {
            "cost": 100000,
            "usefulLifeYears": 5,
            "method": "declining-balance"
          },
          "expected": {
            "ok": false,
            "field": "decliningBalanceEligibilityConfirmed",
            "errorCode": "REQUIRED"
          },
          "tolerance": 1e-09
        },
        {
          "caseId": "declining-with-confirmation",
          "scenario": "positive",
          "input": {
            "cost": 100000,
            "usefulLifeYears": 5,
            "method": "declining-balance",
            "decliningBalanceEligibilityConfirmed": true
          },
          "expected": {
            "ok": true,
            "value": {
              "cost": 100000,
              "usefulLifeYears": 5,
              "method": "declining-balance",
              "depreciationRatePercent": 40,
              "firstYearExpense": 40000,
              "totalDepreciation": 100000
            }
          },
          "tolerance": 1e-09
        }
      ]
    },
    "lastReviewed": "2026-08-24"
  }
];
